import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModuleSharedComponentModule } from '@root/router/component/module-shared-component.module';

@NgModule({
  imports: [
    CommonModule,
    ModuleSharedComponentModule
  ],
  exports: [],
  entryComponents: [],
  declarations: [],
})
export class PagesModule {
  constructor () {
  }
}
